<template>
  <div>
    <el-container>

      <el-header style="display:flex;background-color: #f2f5f6;box-shadow:0px 10px 10px 0px rgba(47,79,47,0.5)">

        <div style="width:14%;height:60px;"></div>

        <div style="width:76%;height:60px;display: flex;">

          <div id="header-company-avatar">
            <el-avatar shape="square" size="large" src="../../jgzs-logo.png"></el-avatar>
          </div>

          <p style="display:inline;float: left;width:10px"></p>

          <div id="header-company">
            <el-button type="text" style="color:green" @click="showHello">
              <span style="font-size:18px">{{ companyName }}</span>
            </el-button>
          </div>
        </div>

        <div style="width:10%;height:60px;display: flex;">

          <div id="header-avatar">
            <el-avatar :src="avatar"></el-avatar>
          </div>

          <div id="header-username">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="personalCenter"
                  v-loading.fullscreen.lock="fullscreenLoading">个人中心</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出系统</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <div style="width: 100%;height: 10px;"></div>

      <el-container style="width:100%;height:775px;">

        <el-aside style="width:216px;background-color: #f2f5f6;box-shadow:10px 0px 10px 0px rgba(47,79,47,0.5)">

          <div style="width: 100%;height: 10px;"></div>

          <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" fill="green" @input="radioInput">
            <el-radio-button :label="true">收起</el-radio-button>
            <el-radio-button :label="false">展开</el-radio-button>
          </el-radio-group>

          <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            @select="handleSelect" :collapse="isCollapse" :unique-opened="true">

            <el-submenu index="1" v-if="kanbanMenu">
              <template slot="title">
                <i class="el-icon-monitor"></i>
                <span slot="title" style="color:green">看板管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/productionKanban">生产看板</el-menu-item>
                <el-menu-item index="/qualityKanban">品质看板</el-menu-item>
                <el-menu-item index="/oEE">OEE看板</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="2" v-if="baseInfoMenu">
              <template slot="title">
                <i class="el-icon-reading"></i>
                <span slot="title" style="color:green">基础资料</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/firstInspectionBase" v-if="firstInspectionMenu">首检项目</el-menu-item>
                <el-menu-item index="/processBase" v-if="processBaseMenu">工序资料</el-menu-item>
                <el-menu-item index="/productTypeBase">产品类别</el-menu-item>

                <el-menu-item index="/productBaseInfo">产品资料</el-menu-item>
                <el-menu-item index="/customerBase">客户资料</el-menu-item>

                <el-menu-item index="/store">仓库资料</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="3" v-if="orderMenu">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span slot="title" style="color:green">订单管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/placeOrder">客户下单</el-menu-item>
                <el-menu-item index="/manufactureOrder" v-if="manufactureOrderMenu">生产订单</el-menu-item>
                <el-menu-item index="/plasticOrder" v-if="plasticOrderMenu">产品订单</el-menu-item>
                <el-menu-item index="/moldPrepare" v-if="moldPrepareMenu">模具整备</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="4" v-if="productionMenu">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span slot="title" style="color:green">生产管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orderLineUp">订单排产</el-menu-item>
                <el-menu-item index="/equipmentManage">设备管理</el-menu-item>
                <el-menu-item index="/workshop">车间管理</el-menu-item>
                <el-menu-item index="/moldRepair">模具管理</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="5" v-if="reckonMenu">
              <template slot="title">
                <i class="el-icon-timer"></i>
                <span slot="title" style="color:green">计件管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/reckonNumberRecord">计件记录</el-menu-item>
                <el-menu-item index="/reckonStatistic">员工统计</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="6" v-if="qualityMenu">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title" style="color:green">品质管控</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/patrolPoint">巡检点</el-menu-item>
                <el-menu-item index="/patrolRecord">巡检记录</el-menu-item>
                <el-menu-item index="/patrolStatistic">巡检统计</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="7" v-if="warehouseMenu">
              <template slot="title">
                <i class="el-icon-house"></i>
                <span slot="title" style="color:green">仓库管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/productStock">库存</el-menu-item>
                <el-menu-item index="/inStock">入库</el-menu-item>
                <el-menu-item index="/outStock">出库</el-menu-item>
                <el-menu-item index="/inventoryCheck">盘点</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="8" v-if="reportMenu">
              <template slot="title">
                <i class="el-icon-notebook-2"></i>
                <span slot="title" style="color:green">报表管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/operationRecord" v-if="operationRecordMenu">操作记录表</el-menu-item>
                <el-menu-item index="/orderInspection" v-if="orderInspectionMenu">首检记录表</el-menu-item>
                <el-menu-item index="/changeProdStatistic" v-if="changeProdMenu">转产统计表</el-menu-item>
                <el-menu-item index="/checkWorkStatistic">考勤统计表</el-menu-item>

                <el-menu-item index="/productInfoRecord">生产记录表</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="9" v-if="factoryMenu">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span slot="title" style="color:green">工厂管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/companyInfo">公司信息</el-menu-item>
                <el-menu-item index="/workSchedule">班次时间</el-menu-item>
                <el-menu-item index="/chkWork">考勤管理</el-menu-item>
                <el-menu-item index="/department">部门管理</el-menu-item>
                <el-menu-item index="/employee">员工管理</el-menu-item>
                <el-menu-item index="/role">角色&权限</el-menu-item>
                <el-menu-item index="/printSetUp">系统设置</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

          </el-menu>
        </el-aside>

        <el-container style="height:775px;">

          <el-main>
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </el-main>

        </el-container>
      </el-container>

      <div style="width: 100%;height: 10px;"></div>

      <el-footer style="background-color: #f2f5f6;box-shadow:0px -10px 10px 0px rgba(47,79,47,0.5)">
        <p>
          <a :href="productHref" target="_blank">生产看板</a><span>&nbsp;|&nbsp;</span>
          <a :href="qualityHref" target="_blank">品质看板</a><span>&nbsp;|&nbsp;</span>
          <a :href="outStockHref" target="_blank">出库看板</a><span>&nbsp;|&nbsp;</span>
          <a :href="productStockHref" target="_blank">库存看板</a><span>&nbsp;|&nbsp;</span>
          <a :href="oEEHref" target="_blank">OEE</a>
        </p>
        <p style="color: green;"><a href="https://beian.miit.gov.cn">粤ICP备2022114400号-4</a></p>
      </el-footer>

    </el-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      dPath: this.getDefaultPath(),
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      companyName: '中国制造',

      isCollapse: false,
      isShowHello: true,
      isShowPage: '',

      username: 'wx_ijbvzt',
      avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      fullscreenLoading: false,

      kanbanMenu: false,
      baseInfoMenu: false,
      orderMenu: false,
      productionMenu: false,
      reckonMenu: false,
      qualityMenu: false,
      warehouseMenu: false,
      reportMenu: false,
      factoryMenu: false,

      processBaseMenu: false,
      manufactureOrderMenu: false,

      plasticOrderMenu: true,
      firstInspectionMenu: true,
      moldPrepareMenu: true,
      operationRecordMenu: true,
      orderInspectionMenu: true,
      changeProdMenu: true,

      productHref: '',
      qualityHref: '',
      outStockHref: '',
      productStockHref: '',
      oEEHref: ''
    }
  },
  components: {

  },
  methods: {
    showHello() {

      this.isShowPage = ''

      this.setDefaultPath('/hello')

      this.$router.push({ path: '/hello' })
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath)
    },
    //菜单切换
    handleSelect(key, keyPath) {

      console.log('Home.vue--handleSelect()')
      console.log(key)
      //key: /moldPrepare

      if (key.length > 3) {

        this.setDefaultPath(key)

        this.dPath = key

        this.$router.push({ path: key })/*.catch(err => {err})*/
      }

      this.isShowPage = key

      this.isShowHello = false

      // console.log(keyPath)
    },
    handleCommand(command) {
      if (command == "logout") {

        this.logout()

      } else if (command == "personalCenter") {

        this.personalCenter(1)
      }
    },
    personalCenter(val) {

      this.isShowPage = false

      this.setPersonalCenter(val)

      this.isShowHello = false

      // console.log("start")

      this.fullscreenLoading = true

      setTimeout(() => {

        this.isShowHello = true

        this.fullscreenLoading = false
      }, 900)
    },
    logout() {
      this.$axios({
        method: "POST",
        url: "/shiro/sys/logout",
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        if (result.status === 200) {

          const data = result.data

          if (data.status === 200) {

            this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
              duration: "1600"
            })

          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error",
              duration: "3000"
            })
          }

          this.setToken("")

          this.$router.push({ path: "/Login" })

        } else {

          this.$message({
            showClose: true,
            message: "操作失败，请联系管理员",
            type: "error",
            duration: "3000"
          })
        }
      })
    },
    radioInput(val) {
      //console.log(val)
    },
    getUser() {
      // console.log('getUser')
      // console.log(this.token)
      this.$axios({
        method: "get",
        url: "/shiro/user/get?userId=" + this.userId,
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        if (data.status === 400) {

          this.$message(data.msg)

          this.$router.push({ path: "/Login" })
        }

        this.username = data.data.username
        // console.log('setUserName')

        this.setUserName(data.data.username)

        this.avatar = data.data.avatar
      })
    }
  },
  mounted() {

    console.log('Home.vue-->mounted()')
    console.log(this.dPath)

    var dp = this.getDefaultPath()

    console.log(dp)

    this.setCurrentSystem(0)

    this.$router.push({ path: dp }).catch(err => { err })

    this.setPersonalCenter(0)

    this.getUser()

    this.$axios({
      method: "post",
      url: "/shiro/menu/get",
      data: {
        companyId: this.companyId
      }, headers: {
        token: this.token
      }
    }).then(result => {

      const data = result.data

      this.companyName = data.data.companyName

      this.kanbanMenu = data.data.kanbanMenu == 0 ? false : true
      this.baseInfoMenu = data.data.baseInfoMenu == 0 ? false : true
      this.orderMenu = data.data.orderMenu == 0 ? false : true
      this.productionMenu = data.data.productionMenu == 0 ? false : true
      this.reckonMenu = data.data.reckonMenu == 0 ? false : true
      this.qualityMenu = data.data.qualityMenu == 0 ? false : true
      this.warehouseMenu = data.data.warehouseMenu == 0 ? false : true
      this.reportMenu = data.data.reportMenu == 0 ? false : true
      this.factoryMenu = data.data.factoryMenu == 0 ? false : true

      var companyType = data.data.companyType
      //流水加工
      if (companyType == 1) {

        this.processBaseMenu = true
        this.manufactureOrderMenu = true

        this.plasticOrderMenu = false
        this.firstInspectionMenu = false
        this.moldPrepareMenu = false
        this.operationRecordMenu = false
        this.orderInspectionMenu = false
        this.changeProdMenu = false
      }

      this.productHref = 'https://www.jzxmes.cn/#/pkb?cid=' + this.companyId + '&p=0'
      this.qualityHref = 'https://www.jzxmes.cn/#/qkb?cid=' + this.companyId + '&p=0'
      this.outStockHref = 'https://www.jzxmes.cn/#/oskb?cid=' + this.companyId + '&p=0'

      this.productStockHref = 'https://www.jzxmes.cn/#/pskb?cid=' + this.companyId + '&p=0'
      this.oEEHref = 'https://www.jzxmes.cn/#/oekb?cid=' + this.companyId + '&p=0'
    })

  }
}
</script>

<style lang="stylus"></style>

<style>
body {
  font-family: 微软雅黑;
  text-align: center;
}

.el-table {
  color: black;
}

#header-company-avatar {
  padding: 10px 0;
}

#header-company {
  padding: 10px 0;
}

#header-username {
  padding: 20px 0px 20px 10px;
}

#header-avatar {
  padding: 10px 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: green;
}

.el-icon-arrow-down {
  font-size: 13px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

#hello-hello {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
  color: green;
  background-color: #f2f5f6;
  border-radius: 5px;
  border: 1px solid green;
  margin: 0 0 20px 0;
}

.el-menu-item {
  color: rgb(44, 179, 44);
}

.el-menu-item.is-active {
  color: white;
  background-color: green;
}
</style>